import React, { useEffect, useRef, useState } from "react";
import WebIM from 'agora-chat';
import { agoraViewModel } from "../common/agora.view.model";
import { useAuth } from "../auth/Auth";
import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import { Spinner } from "react-bootstrap";
import Switch from "react-switch";
import { GrEmoji } from "@react-icons/all-files/gr/GrEmoji";
import RoundButton from "../common/RoundButton";
import { BsLockFill } from "@react-icons/all-files/bs/BsLockFill";
import { schoolViewModel } from "../views/school/school.view.model";
import { useHistory } from "react-router";

export default function TribeChat({ challenge }) {
  const history = useHistory();
  const AGORA_CHAT_APPKEY = '61748012#1001929';
  const { dependent, partner, school } = useAuth();
  const [userToken, setUserToken] = useState();
  const [appToken, setAppToken] = useState(null);
  const [peerId, setPeerId] = useState(challenge?.agora_group_id ? challenge.agora_group_id : '');
  const [peerMessage, setPeerMessage] = useState("");
  const [incommingMessages, setIncommingMessages] = useState([]);
  const [uniqueMessages, setUniqueMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isDisable, setIsDisable] = useState(true);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [checked, setChecked] = useState(challenge.agora_chat_box);
  const [username, setUsername] = useState(challenge ? String(challenge.treehouse_id?.id) : "");
  const messagesEndRef = useRef(null);

  useEffect(() => {
    setIncommingMessages([])
    setPeerId(challenge?.agora_group_id ? challenge.agora_group_id : '')
    setChecked(challenge.agora_chat_box);
    setUsername(challenge ? String(challenge.created_by?.id) : "")
    if (challenge.agora_group_id) getAppToken()
  }, [challenge])

  function getRandomInt(max) {
    return Math.floor(Math.random() * max);
  }

  WebIM.conn = new WebIM.connection({
    appKey: AGORA_CHAT_APPKEY,
  });

  const getUserToken = async (uuid) => {
    let res = await agoraViewModel.getUserToken(uuid)
    setUserToken(res.data.user_token)
  }

  const getAppToken = async () => {
    let res = await agoraViewModel.getAppToken()
    setAppToken(res.data.app_token)
  }

  const getUser = async () => {
    let data = {
      username: username,
      appToken: appToken
    }
    await agoraViewModel.getUser(data).then((res) => {
      localStorage.setItem('uuid', res.entities[0].uuid)
      getUserToken(res.entities[0].uuid)
    }).catch((err) => {
      console.log(err)
    })
  }

  const loginUser = async () => {
    if (userToken !== null) {
      await WebIM.conn.open({
        user: username,
        agoraToken: userToken,
      });
    } else {
      getUserToken(localStorage.getItem('uuid'))
    }
  }

  useEffect(() => {
    // if (challenge.agora_group_id) getAppToken()
    return () => {
      WebIM.conn.removeEventHandler("connection&message")
    }
  }, [])

  useEffect(() => {
    if (challenge.agora_group_id) getUser()
    // getGroupInfo()
    // addUserToGroup()
  }, [appToken])

  useEffect(() => {
    if (challenge.agora_group_id) loginUser()
  }, [userToken])

  const mergeMessages = (previousList, newList) => {
    const list = previousList ? [...previousList, ...newList] : newList;
    let idSet = new Set();

    const uniqueList = list.filter((item) => {
      let isUnique = false;
      if (!idSet.has(item.id)) {
        idSet.add(item.id);
        isUnique = true;
      }
      return isUnique;
    });
    return uniqueList;
  };

  const uniqueIds = (objects) => {
    const uniqueIds = [];
    const uniqueMessage = [];
    objects.forEach((object) => {
      if (!uniqueIds.includes(object.id)) {
        uniqueIds.push(object.id);
        uniqueMessage.push(object);
      }
    });
    return uniqueMessage;
  };

  useEffect(() => {
    setUniqueMessages(uniqueIds(incommingMessages))
  }, [incommingMessages])

  useEffect(() => {
    if (uniqueMessages.length > 0) {
      messagesEndRef.current.scrollIntoView(
        {
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest'
        }
      )
    }
  }, [uniqueMessages])

  WebIM.conn.addEventHandler("connection&message", {
    // Occurs when the app is connected to Agora Chat.
    onConnected: () => {
      console.log("Connected");
      setLoading(false);
      // console.log(localStorage.getItem('uuid'))
    },
    // Occurs when the app is disconnected from Agora Chat.
    onDisconnected: () => {
      console.log("Disconnected");
      // loginUser()
      // refreshToken();
    },
    // Occurs when a text message is received.
    onTextMessage: (message) => {
      console.log(message)
      if (message.to === peerId) {
        console.log(incommingMessages.findIndex(obj => obj.id === message.id))
        // if(incommingMessages.findIndex(obj => obj.id === message.id))
        setIncommingMessages(prevState => [...prevState, message]);
      }
    },
    // Occurs when the token is about to expire.
    onTokenWillExpire: (params) => {
      // console.log("Token is about to expire");
      // refreshToken();
      getUserToken(localStorage.getItem('uuid'));
    },
    // Occurs when the token has expired. You need to get a token from your app server to log in to Agora Chat.
    onTokenExpired: (params) => {
      // console.log("The token has expired");
      // getUserToken(localStorage.getItem('uuid'));
    },
    onError: (error) => {
      console.log("on error", error);
    },
  });

  const onChat = () => {
    let data = {
      username: username,
      peerId: peerId,
      peerMessage: peerMessage,
      appToken: appToken,
    }

    agoraViewModel.sendGroupMessage(data)
    setPeerMessage("")
    setIsDisable(true);
    // window.scrollTo(0, 0);
  }

  const onMessageType = (e) => {
    setPeerMessage(e.target.value)
    if (e.target.value) {
      setIsDisable(false);
    } else {
      setIsDisable(true)
    }
  }

  const handleTribeChatToggle = nextChecked => {
    setChecked(nextChecked);
    let body = {
      name: challenge?.name,
      day: challenge?.day,
      time: challenge?.time,
      time_zone: challenge?.timezone,
      age_group: challenge?.age_group,
      camp_captain_id: challenge?.camp_captain_id,
      agora_group_id: challenge?.agora_group_id,
      agora_chat_box: nextChecked
    }
    schoolViewModel.ediTribe(challenge?.treehouse_id, body).then((res) => {
      // getTreehouses();
    }).catch((err) => {
      console.log(err)
    })
  }

  const handleEmojiClick = (emoji) => {
    setPeerMessage(peerMessage + emoji.native);
    setIsDisable(false)
  };

  const toggleEmojiPicker = () => {
    setShowEmojiPicker((prev) => !prev);
  };

  useEffect(() => {
    const unlisten = history.listen(() => {
      console.log('User is leaving the page');
    });

    return () => {
      unlisten();
      handleTribeChatToggle(false)
    };
  }, [history]);

  return (
    !challenge?.agora_group_id ?
      <div className="chat-area-wrapper hide-on-toggle">
        <span className='lock-ic'><BsLockFill /></span>
      </div>
      :
      <>
        <div className="hide-on-toggle">
          {school && school?.id &&
            <ul className="chat-flex">
              <li><h3>Turn the chat {checked ? 'off' : 'on'}</h3></li>
              <li className={checked ? 'switch-chat' : 'switch-chat-off'}>
                <Switch
                  onChange={handleTribeChatToggle}
                  checked={checked}
                  className="react-switch"
                /></li>
            </ul>
          }
        </div>
        {!checked ?
          <div className="chat-area-wrapper hide-on-toggle">
            <span className='lock-ic'><BsLockFill /></span>
          </div>
          :
          <div className='chat-area-wrapper hide-on-toggle'>
            {loading ?
              <Spinner
                key={0}
                className="home-feed-spinner"
                animation="border"
                variant="info"
              /> :
              <>
                <div className='chat-title'>
                  Welcome to the chat room! 😊
                </div>
                <div className='chat-area-body'>
                  {uniqueMessages.map((item, key) => {
                    return (
                      <div ref={messagesEndRef} className={`chat-user-${getRandomInt(6)} chating-line`} key={item.id}>
                        {
                          Number(item.from) === challenge.created_by?.id ?
                            <>
                              {challenge.created_by?.picture_url && <img className="chat-profile-img" src={challenge.created_by?.picture_url} />}
                              <span className='admin-name'>
                                {challenge.created_by?.first_name + ' ' + challenge.created_by?.last_name}
                                <button className="blue-admin-button">{challenge?.isCaptain ? 'Captain' : 'Admin'}</button>
                              </span> : {item.msg}
                            </>
                            :
                            <><span className='user_nam'>{item.from}</span>: {item.msg}</>
                        }
                      </div>
                    )
                  })}
                  <div />
                </div>
                <div className='chat-type-wrapper'>
                  <form id="form_id_tribe" onSubmit={(e) => { e.preventDefault(); onChat() }}>
                    <div className='chat-input'>
                      <input type="text" name='peerMessage' id='peerMessage' value={peerMessage} onChange={onMessageType} placeholder='Send a message' />
                      <span className='emoji-select add-pointer' onClick={toggleEmojiPicker}><GrEmoji /></span>
                    </div>
                    <RoundButton
                      onClick={onChat}
                      type="submit"
                      label="Chat"
                      className="mt-3 mb-2 gred-btn font-weight-bold chat-btn"
                      disabled={isDisable}
                    />
                  </form>
                  {showEmojiPicker && (
                    <Picker
                      data={data}
                      onEmojiSelect={handleEmojiClick}
                      perLine={8}
                    />
                  )}
                </div>
              </>
            }
          </div>
        }
      </>
  )
}